import ApiService from "./api";

const Media = {
    get(mediaUrl, params) {
        return ApiService.get('media/'+mediaUrl, {params: params});
    },
};

export default Media;